/**
 * Convert any YouTube link format to embed URL.
 * Supports: watch?v=, youtu.be/, /embed/, /shorts/, or bare 11-char videoId.
 * Returns null if no valid YouTube video ID found.
 */
export function toYoutubeEmbedUrl(input) {
  if (!input || typeof input !== 'string') return null;
  const s = input.trim();

  let m;

  // Already embed URL (youtube.com hoặc youtube-nocookie.com)
  m = s.match(/youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube-nocookie.com/embed/${m[1]}`;

  // watch?v=ID
  m = s.match(/[?&]v=([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube-nocookie.com/embed/${m[1]}`;

  // youtu.be/ID
  m = s.match(/youtu\.be\/([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube-nocookie.com/embed/${m[1]}`;

  // /shorts/ID
  m = s.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube-nocookie.com/embed/${m[1]}`;

  // Bare 11-char videoId
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return `https://www.youtube-nocookie.com/embed/${s}`;

  return null;
}
